import React from 'react';
import { ReactComponent as ArrowDownIcon } from "../../assets/arrow.svg";

const WelcomePage = ({ onNext }) => {
    return (
        <div className="welcome-page">
            <div className="welcome-glow"></div>
            <div className="welcome-content">
                <h1 className="welcome-title">Добро пожаловать!</h1>
                <p className="welcome-text">
                    Для запуска приложения, нажмите на кнопку «Запуск»
                </p>
                <div className="arrow-container">
                    <ArrowDownIcon className="arrow-down-animated" />
                </div>
            </div>
            <button className="welcome-button" onClick={onNext}>
                Запуск
            </button>
        </div>
    );
};

export default WelcomePage; 